module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/Retractable Telephoto Camera.318095b7.png";